// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__yRzeE","btn":"Links_btn__RoyBt"};